module.exports = __webpack_public_path__ + "img/location_setting_android_1.2af1d2e1.png";